/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(function () {
  /**
   * Constructs the dropdowns with search
   */

  function formatState(state) {
    if (!state.id) {
      return state.text;
    }

    if (state.element.dataset.thumb) {
      var $state = $(
        `<span><img width="50" src="${state.element.dataset.thumb}" loading="lazy" class="img-thumbnail" /> ${state.text}</span>`
      );
    } else {
      var $state = $(
        `<span><img width="50" src="https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=webp&v=1530129081" loading="lazy" class="img-thumbnail" /> ${state.text}</span>`
      );
    }

    return $state;
  }

  const settings = {
    selectOnClose: true,
    templateResult: formatState,
  };

  // Check if the element exists before initializing
  if ($("#plakat-1").length) {
    $("#plakat-1").select2(settings);
  }

  // Check if the element exists before initializing
  if ($("#plakat-2").length) {
    $("#plakat-2").select2(settings);
  }

  // Check if the element exists before initializing
  if ($("#plakat-3").length) {
    $("#plakat-3").select2(settings);
  }

  // Check if the element exists before initializing
  if ($("#plakat-4").length) {
    $("#plakat-4").select2(settings);
  }

  // Check if the element exists before initializing
  if ($("#plakat-5").length) {
    $("#plakat-5").select2(settings);
  }

  // Check if the element exists before initializing
  if ($("#plakat-6").length) {
    $("#plakat-6").select2(settings);
  }
});

document.addEventListener('DOMContentLoaded', function() {
    // Handles header transparency
    var header = document.querySelector('header#section-header');
    var headerHeight = header.offsetHeight;
  
    window.addEventListener('scroll', function() {
      var scrollTop = window.pageYOffset;
      if (scrollTop >= headerHeight) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });


    // Replaces flickerty slider arrows with new ones
    var sliderArrows = document.querySelectorAll('.flickity-prev-next-button');
    sliderArrows.forEach(function(sliderArrow) {
        var newArrow = '<img src="https://cdn.shopify.com/s/files/1/0663/1119/2850/files/arrow.png?v=1678179281" height="45" width="45" loading="lazy" />';
        sliderArrow.innerHTML = newArrow;
    });

        
});
  